export const enum CONFIG_ANIM_TIME {
  SHORT = 300,
  MEDIUM = 400,
  ONE_SECOND = 1000,
  THREE_SECONDS = 3000,
}
